module.exports = __webpack_public_path__ + "media/images/flags/16/Saudi-Arabia-186082b2bf0da5d851b37e593a2cc3fb.png";